export default __webpack_public_path__ + "static/media/glucernaLiq2.ff7ab590.png";